import React, { useEffect, useState } from 'react';
import withCanvasContainer, { WithCanvasContainerProps } from './withCanvasContainer';
import ScoreRenderer from 'components/scores/scoreRenderer';
import { useScores } from 'redux/hooks/searchnFilter';
import { useRMSelector } from 'redux/hooks';
import { selectHideAutoScores, selectScoreGroup } from 'redux/selectors/StateSelectors';
import { filterScores } from '../utils';

type Props = WithCanvasContainerProps;

const ScoreCanvas = (props: Props) => {
  const { wellRectangles, wellRectsPadded, searchResult, canvasRefs } = props;
  const { isFetching, scores } = useScores();
  const [scoresState, setScoresState] = useState(null);
  const hideAutoScores = useRMSelector(selectHideAutoScores);
  const scoresGroup = useRMSelector(selectScoreGroup);

  useEffect(() => {
    const _scores = searchResult.rows.items.map((sr, i) => {
      const rect = wellRectsPadded[i];
      const score =
        scores[`${sr[`Well Drop.ID`]}-${sr[`Capture Result.Image Batch ID`]}`] ?? [];
      const Filteredscore = filterScores(scoresGroup, score, hideAutoScores);
      return Filteredscore ? <ScoreRenderer rect={rect} scores={Filteredscore} /> : null;
    });

    setScoresState(_scores);
    //RFR: need to come up with a better approach.
    setTimeout(() => {
      canvasRefs.layerRef?.cache();
    }, 500);
  }, [searchResult.rows.items, wellRectsPadded, scores, hideAutoScores, scoresGroup]);

  if (!wellRectangles || isFetching) {
    return null;
  }

  return (
    <>
      {wellRectangles}
      {scoresState}
    </>
  );
};

export default withCanvasContainer(ScoreCanvas, 'scoreCanvas');
